import { TrophyFilled } from "@ant-design/icons";
import { Skeleton } from "antd";
import { motion } from "framer-motion";
import React, { ReactNode } from "react";
import { BsDiamondFill } from "react-icons/bs";

interface RadialProps {
  value: number; // The value to represent as a percentage (0-100)
  size: number; // The size of the radial component in pixels
  strokeWidth: number; // The width of the stroke
  strokeColor: string; // The color of the stroke
  children?: ReactNode;
  icon?: "diamond" | "trophy";
  loading?: boolean;
}

const Radial: React.FC<RadialProps> = ({
  value,
  size,
  strokeWidth,
  strokeColor,
  children,
  icon,
  loading,
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = ((100 - value) / 100) * circumference;

  if (loading)
    return (
      <div style={{ width: size, height: size }}>
        <Skeleton.Avatar active size={size} />
      </div>
    );
  return (
    <div className="relative">
      <svg width={size} height={size} className="radial -rotate-90">
        <circle
          className="radial-background"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          stroke={"#D9D9D9"}
          fill="transparent"
        />
        <circle
          className="radial-progress"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          stroke={strokeColor}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
        />
      </svg>
      <div className="w-full h-full absolute top-0 bottom-0 left-0 right-0 flex justify-center items-center">
        {children}
      </div>
    </div>
  );
};

export default Radial;
